import instRequest from 'utils/instRequest'
import studentRequest from 'utils/studentRequest'

// Action types
export const SET_LOADING = 'CORP_ASSESSMENT_SET_LOADING'
export const SET_ERROR = 'CORP_ASSESSMENT_SET_ERROR'
export const SET_ASSESSMENTS = 'CORP_ASSESSMENT_SET_ASSESSMENTS'
export const SET_ASSESSMENT_TYPES = 'CORP_ASSESSMENT_SET_ASSESSMENT_TYPES'
export const SET_KPI_DATA = 'CORP_ASSESSMENT_SET_KPI_DATA'
export const SET_STUDENTS = 'CORP_ASSESSMENT_SET_STUDENTS'
export const SET_STUDENTS_LOADING = 'CORP_ASSESSMENT_SET_STUDENTS_LOADING'
export const SET_REPORT = 'CORP_ASSESSMENT_SET_REPORT'
export const SET_REPORT_LOADING = 'CORP_ASSESSMENT_SET_REPORT_LOADING'

export const fetchCorporateAssessments = (params = {}) => async (dispatch, getState) => {
  const state = getState()
  const corporateId = state.auth.corporateId

  dispatch({ type: SET_LOADING, data: true })
  dispatch({ type: SET_ERROR, data: null })

  try {
    // Map to backend's expected query params:
    // getCorporateAssessmentsInfo(corporateId, pageNo, pageLimit, searchBy, order, sort, type_name)
    const queryParams = {
      corporateId,
      pageNo: (params.page || 1) - 1, // Backend uses 0-based page
      pageLimit: params.pageSize || 10,
      searchBy: params.search || '',
      order: params.order || 'start_time',
      sort: params.sort || 'desc',
      type_name: params.type_name || '',
    }

    const response = await instRequest.get(
      '/institutes/studentListInfo/getCorporateAssessmentsInfo',
      { params: queryParams }
    )

    // Response structure: { data: { data: { data: [...], pagination: {...} } } }
    const responseData = response.data?.data || {}
    const assessments = responseData.data || []
    const pag = responseData.pagination || {}

    dispatch({
      type: SET_ASSESSMENTS,
      data: {
        assessments,
        pagination: {
          currentPage: pag.currentPage || 1,
          totalPages: pag.totalPages || 0,
          totalCount: pag.totalCount || 0,
          pageSize: pag.pageSize || params.pageSize || 10,
        },
      },
    })
  } catch (error) {
    console.error('Error fetching corporate assessments:', error)
    dispatch({ type: SET_ERROR, data: error.message || 'Failed to fetch assessments' })
  } finally {
    dispatch({ type: SET_LOADING, data: false })
  }
}

export const fetchCorporateAssessmentTypes = () => async (dispatch, getState) => {
  const state = getState()
  const corporateId = state.auth.corporateId

  try {
    const response = await instRequest.get(
      '/institutes/studentListInfo/getAssessmentTypes',
      { params: { corporateId } }
    )

    // Response: { data: { data: [...] } }
    const types = response.data?.data || []
    dispatch({
      type: SET_ASSESSMENT_TYPES,
      data: types,
    })
  } catch (error) {
    console.error('Error fetching assessment types:', error)
  }
}

export const fetchCorporateAssessmentStates = () => async (dispatch, getState) => {
  const state = getState()
  const corporateId = state.auth.corporateId

  try {
    const response = await studentRequest.get(
      `/students/assessments/getAssessmentStatesForCorporate/${corporateId}`
    )

    // Response: { data: { data: { totalCandidates, ... } } }
    const data = response.data?.data || {}
    dispatch({
      type: SET_KPI_DATA,
      data: {
        totalCandidates: data.totalCandidates || 0,
        totalAssessmentsSent: data.totalAssessmentsSent || 0,
        totalAssessmentsTaken: data.totalAssessmentsTaken || 0,
        totalPracticeTests: data.totalPracticeTests || 0,
      },
    })
  } catch (error) {
    console.error('Error fetching assessment states:', error)
  }
}

export const fetchCorporateAssessmentStudents = (params = {}) => async (dispatch) => {
  dispatch({ type: SET_STUDENTS_LOADING, data: true })

  try {
    const queryParams = {
      assessmentCorporateMapId: params.assessmentCorporateMapId,
      pageNo: (params.page || 1) - 1,
      pageLimit: params.pageSize || 10,
      searchBy: params.search || '',
    }

    const response = await instRequest.get(
      '/institutes/studentListInfo/getCorporateAssessmentStudents',
      { params: queryParams }
    )

    const responseData = response.data?.data || {}
    const students = responseData.data || []
    const pag = responseData.pagination || {}

    dispatch({
      type: SET_STUDENTS,
      data: {
        students,
        pagination: {
          currentPage: pag.currentPage || 1,
          totalPages: pag.totalPages || 0,
          totalCount: pag.totalCount || 0,
          pageSize: pag.pageSize || params.pageSize || 10,
        },
      },
    })
  } catch (error) {
    console.error('Error fetching assessment students:', error)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, data: false })
  }
}

export const fetchAssessmentReport = (params = {}) => async (dispatch) => {
  dispatch({ type: SET_REPORT_LOADING, data: true })

  try {
    const response = await studentRequest.post(
      '/students/getAssessmentReport',
      {
        assessmentAssignedId: params.assessmentAssignedId,
      }
    )

    const data = response.data?.data || null
    dispatch({
      type: SET_REPORT,
      data,
    })
  } catch (error) {
    console.error('Error fetching assessment report:', error)
  } finally {
    dispatch({ type: SET_REPORT_LOADING, data: false })
  }
}
